import { TreatmentTrackOptions } from 'consts/giConsts'
import { TrackStatusColors } from 'consts/txTrackingReportConsts'
import React from 'react'
import { useTranslation } from 'react-i18next'

// Original vectors from Figma frame 220: Group 6341 (on track) and Group 6340 (not on track), at 24px.
const TrackStatusIcon = ({ trackStatus }) => {
  const { t } = useTranslation()
  const isOnTrack = trackStatus === TreatmentTrackOptions.OnTrack
  const label = t(`pages.txTrackingReport.patientsList.categories.${isOnTrack ? 'onTrack' : 'notOnTrack'}`)

  return isOnTrack ? (
    <svg width={24} height={24} viewBox="899 312 24 24" fill="none" role="img" aria-label={label}>
      <ellipse cx="911" cy="324" rx="12" ry="12" transform="rotate(90 911 324)" fill={TrackStatusColors.onTrack} />
      <path d="M904.457 324.001L908.821 328.365L918.639 318.547" stroke="white" strokeWidth="3" />
    </svg>
  ) : (
    <svg width={24} height={24} viewBox="953.402 312 24 24" fill="none" role="img" aria-label={label}>
      <ellipse
        cx="965.402"
        cy="324"
        rx="12"
        ry="12"
        transform="rotate(90 965.402 324)"
        fill={TrackStatusColors.notOnTrack}
      />
      <path d="M965.406 316.365V325.093" stroke="white" strokeWidth="3" />
      <path d="M965.406 328L965.406 331.636" stroke="white" strokeWidth="3" />
    </svg>
  )
}

export default TrackStatusIcon
